import styled from "styled-components";

export const WelcomeText = styled.div`
  font-size: 16px;
  margin: 16px 0 16px 0;
  text-align: center;
`;
